__turbopack_context__.v({
  "checkoutButton": "C11pRa_checkoutButton",
  "closeButton": "C11pRa_closeButton",
  "content": "C11pRa_content",
  "drawer": "C11pRa_drawer",
  "empty": "C11pRa_empty",
  "emptyText": "C11pRa_emptyText",
  "error": "C11pRa_error",
  "footer": "C11pRa_footer",
  "header": "C11pRa_header",
  "heading": "C11pRa_heading",
  "holdTimers": "C11pRa_holdTimers",
  "overlay": "C11pRa_overlay",
  "panel": "C11pRa_panel",
  "section": "C11pRa_section",
  "sectionHeader": "C11pRa_sectionHeader",
  "sectionIcon": "C11pRa_sectionIcon",
  "sectionItems": "C11pRa_sectionItems",
  "sectionLabel": "C11pRa_sectionLabel",
  "sections": "C11pRa_sections",
  "shippingNote": "C11pRa_shippingNote",
  "subtotalRow": "C11pRa_subtotalRow",
  "title": "C11pRa_title",
});
